<template>
  <div>
    <v-dialog v-model="modal_add" persistent max-width="760px" scrollable>
      <v-card class="dialog-card">
        <!-- HEADER -->
        <div class="dialog-header">
          <div class="d-flex align-center">
            <div class="dialog-header-icon">
              <v-icon color="white" size="28">
                mdi-clipboard-list-outline
              </v-icon>
            </div>

            <div class="ml-4">
              <div class="dialog-eyebrow">MANAJEMEN JABATAN</div>

              <div class="dialog-title">Tambah Uraian Tugas</div>

              <div class="dialog-subtitle">
                Lengkapi informasi uraian tugas pada jabatan ini.
              </div>
            </div>
          </div>

          <v-btn icon dark class="dialog-close" @click="close_modal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <!-- FORM -->
        <v-card-text class="dialog-content">
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- URAIAN TUGAS -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-text-box-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Uraian Tugas</div>

                  <div class="dialog-section-description">
                    Tuliskan tugas atau pekerjaan yang dilaksanakan.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Uraian Tugas
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="form_data.uraian"
                  placeholder="Masukkan uraian tugas..."
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  counter
                  hide-details="auto"
                  class="dialog-input"
                />
              </div>
            </div>

            <v-divider class="dialog-divider" />

            <!-- BAHAN KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-file-document-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Bahan Kerja</div>

                  <div class="dialog-section-description">
                    Bahan yang diperlukan untuk melaksanakan tugas.
                  </div>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Bahan Kerja
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form_data.bahan.kerja"
                      placeholder="Masukkan bahan kerja..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Penggunaan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form_data.bahan.penggunaan"
                      placeholder="Jelaskan penggunaan bahan..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="dialog-divider" />

            <!-- PERANGKAT KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-tools </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Perangkat Kerja</div>

                  <div class="dialog-section-description">
                    Perangkat atau alat yang menunjang pelaksanaan tugas.
                  </div>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Perangkat Kerja
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form_data.perangkat.kerja"
                      placeholder="Masukkan perangkat kerja..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Digunakan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form_data.perangkat.digunakan"
                      placeholder="Jelaskan penggunaan perangkat..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="dialog-divider" />

            <!-- HASIL KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-check-circle-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Hasil Kerja</div>

                  <div class="dialog-section-description">
                    Tentukan hasil, satuan, jumlah, dan waktu penyelesaian.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Hasil Kerja
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="form_data.hasil.kerja"
                  placeholder="Masukkan hasil kerja..."
                  outlined
                  dense
                  rows="2"
                  auto-grow
                  hide-details="auto"
                  class="dialog-input"
                />
              </div>

              <v-row dense class="mt-1">
                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Satuan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form_data.hasil.satuan"
                      placeholder="Contoh: Dokumen"
                      outlined
                      dense
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Jumlah
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form_data.hasil.jumlah"
                      placeholder="Masukkan jumlah"
                      outlined
                      dense
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Waktu (Satuan Menit)
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form_data.hasil.waktu"
                      placeholder="Contoh: 120"
                      suffix="Menit"
                      outlined
                      dense
                      hide-details="auto"
                      class="dialog-input"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="dialog-footer">
          <div class="dialog-footer-note">
            <v-icon size="17" color="grey"> mdi-information-outline </v-icon>

            <span> Pastikan seluruh data sudah benar. </span>
          </div>

          <v-spacer />

          <v-btn
            depressed
            outlined
            color="grey darken-1"
            class="text-none dialog-cancel-btn"
            :disabled="loading"
            @click="close_modal"
          >
            Batal
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="text-none dialog-submit-btn"
            :loading="loading"
            :disabled="loading"
            @click="add"
          >
            <v-icon left size="18"> mdi-content-save-outline </v-icon>

            Simpan Data
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";
import SData from "@/store/anjab/infojabatan/uraiantugas";

import "@/assets/styles/pages/anjab/infojabatan/uraiantugas/add.css";

export default {
  name: "ModalTambahUraianTugas",

  data() {
    return {
      token: "",
      session: "",
      lbtn: false,
      loading: false,

      valid: true,

      form_data: {
        idjab: "",
        uraian: "",

        bahan: {
          kerja: "",
          penggunaan: "",
        },

        perangkat: {
          kerja: "",
          digunakan: "",
        },

        hasil: {
          kerja: "",
          satuan: "",
          jumlah: "",
          waktu: "",
        },
      },
    };
  },

  computed: {
    modal_add: {
      get() {
        return SData.state.modal_add;
      },

      set(value) {
        if (!value) {
          this.close_modal();
        }
      },
    },

    item() {
      return SData.state.data;
    },
  },

  watch: {
    async modal_add(value) {
      if (value) {
        this.token = await cookie.get("token");
      }
    },
  },

  methods: {
    async add() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        return;
      }

      this.loading = true;

      const data = {
        idjab: this.$route.params.id,
        uraian: this.form_data.uraian,

        bahan: {
          kerja: this.form_data.bahan.kerja,
          penggunaan: this.form_data.bahan.penggunaan,
        },

        perangkat: {
          kerja: this.form_data.perangkat.kerja,
          digunakan: this.form_data.perangkat.digunakan,
        },

        hasil: {
          kerja: this.form_data.hasil.kerja,
          satuan: this.form_data.hasil.satuan,
          jumlah: this.form_data.hasil.jumlah,
          waktu: this.form_data.hasil.waktu,
        },
      };

      const url = `${process.env.VUE_APP_API}/tujab/add`;

      this.axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.lbtn = false;
          if (res.data.success) {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Berhasil Menambah Data");
            SData.commit("alert_b", true);
            SData.commit("alert_g", false);
          } else {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Gagal Menambah Data");
            SData.commit("alert_g", true);
            SData.commit("alert_b", false);
          }

          this.close_modal();
        })
        .catch((error) => {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Gagal Menambah Data");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
          console.log(error.response.status);
          console.log("Error", error.message);
          this.lbtn = false;

          this.close_modal();
        });
    },

    close_modal() {
      SData.commit("close_add", false);

      this.form_data = {
        uraian: "",

        bahan: {
          kerja: "",
          penggunaan: "",
        },

        perangkat: {
          kerja: "",
          digunakan: "",
        },

        hasil: {
          kerja: "",
          satuan: "",
          jumlah: "",
          waktu: "",
        },
      };

      this.valid = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>
